var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSongIdeas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16732 18.1669C5.17984 18.1669 6.00065 17.3461 6.00065 16.3336C6.00065 15.321 5.17984 14.5002 4.16732 14.5002C3.1548 14.5002 2.33398 15.321 2.33398 16.3336C2.33398 17.3461 3.1548 18.1669 4.16732 18.1669ZM4.16732 19.6669C6.00827 19.6669 7.50065 18.1745 7.50065 16.3336C7.50065 14.4926 6.00827 13.0002 4.16732 13.0002C2.32637 13.0002 0.833984 14.4926 0.833984 16.3336C0.833984 18.1745 2.32637 19.6669 4.16732 19.6669Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9988 16.1668C17.0113 16.1668 17.8321 15.346 17.8321 14.3334C17.8321 13.3209 17.0113 12.5001 15.9988 12.5001C14.9862 12.5001 14.1654 13.3209 14.1654 14.3334C14.1654 15.346 14.9862 16.1668 15.9988 16.1668ZM15.9988 17.6668C17.8397 17.6668 19.3321 16.1744 19.3321 14.3334C19.3321 12.4925 17.8397 11.0001 15.9988 11.0001C14.1578 11.0001 12.6654 12.4925 12.6654 14.3334C12.6654 16.1744 14.1578 17.6668 15.9988 17.6668Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.00023H7.5L7.50065 16.3336H6.00065L6 3.00023Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8359 1.00023H19.3359V14.3336H17.8359V1.00023Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.74512V5.69284L17.8333 3.75534V1.80762L7.5 3.74512ZM6 2.91519V6.89776C6 7.21083 6.28444 7.4469 6.59214 7.3892L18.9255 5.0767C19.162 5.03236 19.3333 4.82587 19.3333 4.58526V0.602691C19.3333 0.289622 19.0489 0.05356 18.7412 0.111255L6.40786 2.42375C6.17137 2.4681 6 2.67458 6 2.91519Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.0002H7V14.0002H4V13.0002Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.0002H18V12.0002H16V11.0002Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongIdeas);
export default __webpack_public_path__ + "static/media/songIdeas.4329243e.svg";
export { ForwardRef as ReactComponent };